<template>
	<div id="app">

		<router-view />
	</div>
</template>

<script>
	export default {
		name: 'App'
	}
</script>

<style>
 
	* {
		padding: 0px;
		margin: 0px;
	}

	html,
	body,
	#app {
		width: 100%;
		height: 100%;
		max-width: 40.625rem;
		min-width: 21.25rem; 
		background: #fafafa;
		margin: 0 auto;
		font-family:"微软雅黑";
	}

	#app {
		font-family: 'Avenir', Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		font-size: 15px;
	}

	/*菜单切换颜色*/
	.van-tabs__line {
		background-color: #007CCF !important;
	}

	.van-overlay {
		background-color: rgba(0, 0, 0, 0.6) !important;
	}

	.font15 {
		font-size: 15px;
	}

	.font10 {
		font-size: 10;
	}

	.col666 {
		color: #666;
	}

	.col999 {
		color: #999;
	}
    .col333 {
		color: #333;
	}
	.col333f {
		color: #333;
		font-weight: bold;
	}
	.w95{
		width: 95%;
	}
	.van-popup--left{
		height: 100%;
	}
		.countent1 img{
		width: 98%;
		height: 100%;
	}
</style>



// WEBPACK FOOTER //
// src/App.vue